import { render, staticRenderFns } from "./patents.vue?vue&type=template&id=e56ce9f0&scoped=true"
import script from "./patents.vue?vue&type=script&lang=js"
export * from "./patents.vue?vue&type=script&lang=js"
import style0 from "./patents.vue?vue&type=style&index=0&id=e56ce9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ce9f0",
  null
  
)

export default component.exports